module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-modale"
  }, [_c('div', {
    staticClass: "panel-modale__inner",
    style: (_vm.getModalFormWidth)
  }, [_c('button', {
    staticClass: "panel-modale__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("✖")]), _vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39d792e0","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/panel/Modal.vue
// module id = 91d7972d1f4621164a77
// module chunks = 8